import { useEffect } from 'react';
import { Form, Input, Modal } from 'antd';
import { useSetPasswordMutation } from '@/services/users-api';

const SetPasswordModal = ({ userId, open, onClose }) => {
  const [setPassword, { isLoading: saving }] = useSetPasswordMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [open, form]);

  const onFinish = async (body) => {
    try {
      await setPassword({ userId, body }).unwrap();
      onClose();
    } catch (err) {}
  };

  return (
    <>
      <Modal
        title="Set password"
        open={open}
        confirmLoading={saving}
        onOk={() => form.submit()}
        onCancel={onClose}
        width={600}
      >
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Form.Item
            name="newPassword"
            label="New Password"
            rules={[
              { required: true },
              { pattern: /[A-Z]+/, message: 'Include upper case characters' },
              { pattern: /[a-z]+/, message: 'Include lower case characters' },
              { pattern: /[0-9]+/, message: 'Include at least on number' },
              { min: 6, message: 'Be at least 6 characters long' },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="Confirm Password"
            dependencies={['newPassword']}
            rules={[
              {
                required: true,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('New Password that you entered do not match'));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default SetPasswordModal;
